<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
 
  }
}
</script>

<style lang="less" >
body {
  height: 100%;
  width: 100%;
}



</style>
